import { Component, Vue } from 'vue-property-decorator';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';

import Loader from '@/components/Loader/index.vue';

library.add(faPlusCircle);

interface AlphabetItem {
	showValue: string;
	searchValues: string[];
	matchValue: string;
}

@Component({
	components: {
		Loader,
	},
})
export default class TableGroups extends Vue {
	logout() {
		this.$store.dispatch('logout');
	}
}
